module.exports = __webpack_public_path__ + "media/assets/images/category/Christmas@2x-547b7959f62c18301a3aeac7518b0bd0.png";